import styled from '@emotion/styled';
import { colors, fonts, layout } from './theme';

const Root = styled.section`
  background: ${colors.coreBlue};
  padding: clamp(56px, 8vw, 96px) 0;
`;

const Inner = styled.div`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 32px);
  scroll-margin-top: 90px;
`;

const Eyebrow = styled.p`
  font-family: ${fonts.mono};
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors.signalBlue};
  margin: 0 0 16px;
`;

const Headline = styled.h2`
  font-family: ${fonts.sans};
  font-size: clamp(32px, 3.8vw, 48px);
  line-height: 1.15;
  max-width: 22ch;
  font-weight: 400;
  color: ${colors.baselineWhite};
  margin: 0 0 40px;
`;

const StatRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  margin-bottom: 24px;

  @media (min-width: 800px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const StatColumn = styled.div`
  border-top: 1px solid ${colors.borderInverse};
  padding-top: 16px;
`;

const StatValue = styled.p`
  font-family: ${fonts.sans};
  font-size: 64px;
  line-height: 1.1;
  letter-spacing: -0.02em;
  font-weight: 400;
  color: ${colors.baselineWhite};
  margin: 0 0 8px;
`;

const StatLabel = styled.p`
  font-family: ${fonts.mono};
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors.textMutedDarkBg};
  margin: 0;
`;

const VerifiedBy = styled.p`
  font-family: ${fonts.mono};
  font-size: 13px;
  letter-spacing: 0.06em;
  color: #7b93a6;
  margin: 0;
`;

const STATS = [
  { value: '+83%', label: 'CTR VS KPI' },
  { value: '+61%', label: 'Attention vs social benchmarks' },
  { value: '+24%', label: 'Brand consideration' },
];

export default function CaseStudiesSection() {
  return (
    <Root>
      <Inner id="case-studies">
        <Eyebrow>Case Studies</Eyebrow>
        <Headline>agencies and brands buy the outcome</Headline>
        <StatRow>
          {STATS.map((stat) => (
            <StatColumn key={stat.label}>
              <StatValue>{stat.value}</StatValue>
              <StatLabel>{stat.label}</StatLabel>
            </StatColumn>
          ))}
        </StatRow>
        <VerifiedBy>
          Verified by Lumen attention measurement and Happydemics brand uplift studies
        </VerifiedBy>
      </Inner>
    </Root>
  );
}
